module Dashboard {
    "use strict";
    
    export class DashboardController {
        public gridsterOpts: any;
        public chartData: any;
        public chartOptions: any;

        static $inject = ["DashboardConfigService"];
        constructor(private dashboardConfigService: DashboardConfigService) {
            this.gridsterOpts = {
                columns: 100,               // the width of the grid, in columns
                pushing: false,             // whether to push other items out of the way on move or resize
                floating: false,            // whether to automatically float items up so they stack
                swapping: false,            // items of the same size switch places
                width: "auto",              // can be an integer or "auto". "auto" scales gridster to be the full width of its containing element
                colWidth: 100,              // can be an integer or "auto".  "auto" uses the pixel width of the element divided by "columns"
                rowHeight: "match",         // can be an integer or "match".  Match uses the colWidth, giving you square widgets.
                margins: [10, 10],          // the pixel distance between each widget
                outerMargin: true,          // whether margins apply to outer edges of the grid
                isMobile: false,            // stacks the grid items if true
                mobileBreakPoint: 900,      // if the screen is not wider that this, remove the grid layout and stack the items
                mobileModeEnabled: true,    // whether or not to toggle mobile mode when screen width is less than mobileBreakPoint
                minColumns: 1,              // the minimum columns the grid must have
                minRows: 1,                 // the minimum height of the grid, in rows
                maxRows: 1000,              // the maximum height of the grid, in rows
                defaultSizeX: 4,            // the default width of a gridster item, if not specifed
                defaultSizeY: 4,            // the default height of a gridster item, if not specified
                minSizeX: 2,                // minimum column width of an item
                maxSizeX: null,             // maximum column width of an item
                minSizeY: 1,                // minumum row height of an item
                maxSizeY: null,             // maximum row height of an item
                resizable: {
                    enabled: true,
                    handles: ["se"], // "n", "e", "s", "w", "ne", "se", "sw", "nw"
                    start: (event, $element, widget) => { },
                    resize: (event, $element, widget) => { },
                    stop: (event, $element, widget) => {
                        dashboardConfigService.save();
                    }
                },
                draggable: {
                    enabled: true,
                    handle: ".drag-handle",
                    start: (event, $element, widget) => { },
                    drag: (event, $element, widget) => { },
                    stop: (event, $element, widget) => {
                        dashboardConfigService.save();
                    }
                }
            };
        }
    }

    module.controller("DashboardController", DashboardController);
}